import Swiper from 'swiper';
import { Pagination } from 'swiper/modules';
import { setupSwiperPaginationWindow } from '../../src/js/includes/_1_swiper-pagination-window.js';

document.addEventListener('DOMContentLoaded', function() {
    EventsSlider();
});

function EventsSlider() {
    var swipers = document.querySelectorAll('.swiper.slider-events');

    swipers.forEach(function(swiper) {

        var swiperSlider = new Swiper(swiper, {
            modules: [Pagination],
            loop: false,
            speed: 500,
            slidesPerView: 1.1,
            spaceBetween: 32,
            keyboard: {
                enabled: true,
            },
            pagination: {
                el: swiper.querySelector('.swiper-pagination'),
                clickable: true,
            },
            breakpoints: {
                786: {
                    slidesPerView: 2,
                }
            }
        });

        setupSwiperPaginationWindow(swiperSlider, { visible: 5 });
    });
}